import { post } from '../../../../TstcIndex/src/apis/Request';
import { axiosPost } from '../../../../../request/http';
//智慧厕所列表
export const queryToilet = (data) => {
    const params = {
        baseUrl: global.$config.api.apiUrl,
        data: data
    }
    return axiosPost(`/data-api/data/data-server/resToiletInfo/findToilet`, params)
};
//智慧厕所详情
export const queryToiletDetail = (data) => {
    const params = {
        baseUrl: global.$config.api.apiUrl,
        data: data
    }
    return axiosPost(`/data-api/data/data-server/resToiletInfo/findToiletDetail`, params)
};
//智慧厕所编辑
export const ToiletEdit = (data) => {
    const params = {
        baseUrl: global.$config.api.apiUrl,
        data: data
    }
    return axiosPost(`/data-api/data/data-server/resToiletInfo/edit`, params)
};